<ng-container *ngrxLet="activeLanguage$ as activeLanguage">
    <ng-container *ngIf="activeLanguage === 'pl'">
        <p>
            Zakończył się I Etap konkursu prowadzonego przez PAŻP związanego z projektem dronowym KPO. Składanie wniosków w konkursie w
            ramach Etapu I było możliwe od 19.03.2025 r. do 08.05.2025 r. Podczas Etapu I złożonych zostało 45 Wniosków Wstępnych, a 31 z
            nich otrzymało kwalifikację do Etapu II.
        </p>
        <p>
            W wielu przypadkach Uczestnikami konkursu były konsorcja składające się z kilku podmiotów (zazwyczaj gmin), dzięki czemu
            niektórym Uczestnikom udało się zgłosić w konkursie obszary (lokalizacje) obejmujące całkiem dużą powierzchnię.
        </p>
        <p>Poniżej lista Laureatów (wymieniony Lider oraz przybliżona lokalizacja):</p>
        <p>
            GZM (Miasto Bytom, Miasto Zabrze), Gmina Czerwin, Gmina Czempiń, Gmina Garwolin, Gmina Grodków, Gmina Jarocin (2 wnioski), Gmina
            Kisielice, Gmina Kozienice, Gmina Krosno, GZM (miasto Katowice, miasto Tychy), Regionalne Centrum Rozwoju i Edukacji (Miasto
            Lubin), Miasto Nowy Targ, Miasto Opole, Miasto Olsztyn, Gmina Przasnysz, Gmina Padew Narodowa, Województwo Podkarpackie (2
            wnioski), Gmina Redzikowo, Miasto Rzeszów, Miasto Rybnik, Gmina Rybno, Gmina Samborzec, Stalowowolska Agencja Rozwoju
            Regionalnego (Miasto Stalowa Wola), Gmina Strzelce Krajeńskie, Gmina Turośń Kościelna, Miasto Tarnów, Gmina Wola Krzysztoporska,
            Gmina Zbąszyń, Związek Gmin i Powiatów Subregionu Północnego Województwa Śląskiego (miasto Częstochowa).
        </p>
        <p>Serdecznie gratulujemy!</p>
        <br />
        <p>
            W najbliższych dniach przedstawione zostaną bardziej szczegółowe informacje dotyczące Laureatów, m.in. z podziałem Uczestników
            na grupy województw.
        </p>
    </ng-container>
    <ng-container *ngIf="activeLanguage === 'en'">
        <p>
            The first stage of the competition conducted by PANSA related to the KPO drone project has been completed. Applications for the
            competition in Stage I could be submitted from 19.03.2025 to 08.05.2025. During Stage I, 45 Preliminary Applications were
            submitted, and 31 of them qualified for Stage II.
        </p>
        <p>
            In many cases, the competition participants were consortia consisting of several entities (usually municipalities), which
            allowed some participants to submit areas (locations) covering quite a large surface in the competition.
        </p>
        <p>Below is the list of winners (leader and approximate location mentioned):</p>
        <p>
            GZM (City of Bytom, City of Zabrze), Municipality of Czerwin, Municipality of Czempiń, Municipality of Garwolin, Municipality of
            Grodków, Municipality of Jarocin (2 applications), Municipality of Kisielice, Municipality of Kozienice, Municipality of Krosno,
            GZM (City of Katowice, City of Tychy), Regionalne Centrum Rozwoju i Edukacji (City of Lubin), City of Nowy Targ, City of Opole,
            City of Olsztyn, Municipality of Przasnysz, Municipality of Padew Narodowa, Podkarpackie Voivodeship (2 applications),
            Municipality of Redzikowo, City of Rzeszów, City of Rybnik, Municipality of Rybno, Municipality of Samborzec, Stalowowolska
            Agencja Rozwoju Regionalnego (City of Stalowa Wola), Municipality of Strzelce Krajeńskie, Municipality of Turośń Kościelna, City
            of Tarnów, Municipality of Wola Krzysztoporska, Municipality of Zbąszyń, Związek Gmin i Powiatów Subregionu Północnego
            Województwa Śląskiego (City of Częstochowa).
        </p>
        <p>Congratulations!</p>
        <br />
        <p>
            In the coming days, more detailed information about the winners will be presented, including the division of participants into
            voivodeship groups.
        </p>
    </ng-container>
</ng-container>
